// @flow @format
import React, {PureComponent, type Node} from 'react';
import PropTypes from 'prop-types';
import classNames from 'lib/classnames';
import './Footer.css';

type Props = {
	visible: boolean,
	children: Node,
};

class Footer extends PureComponent<Props, void> {
	static propTypes = {
		children: PropTypes.oneOfType([
			PropTypes.node,
			PropTypes.arrayOf(PropTypes.node),
		]),
		visible: PropTypes.bool,
	};

	static defaultProps = {
		visible: false,
		children: [],
	};

	render() {
		const {children, visible} = this.props;

		return (
			<div
				className={classNames({
					Footer: true,
					'Footer--Visible': visible,
				})}
			>
				{children}
			</div>
		);
	}
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js